import classNames from 'classnames';
import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Horizontal } from 'atoms/layout/flex';
import { BodyM } from 'atoms/typography';
import { range } from 'lib/arrays';

const ProgressBar = styled.div`
  display: flex;
  flex: 1;
  gap: 3px;

  & > span {
    height: 6px;
    background-color: var(--c-nd-700);
    flex: 1;
    opacity: 0.3;
    &.active {
      opacity: 1;
      background-color: var(--active-color, var(--c-nd-700));
    }
    &:first-child {
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;
    }
    &:last-child {
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
    }
  }
`;
const Progress = styled(Horizontal)`
  width: 100%;
`;

type Props = {
  count: number;
  max?: number;
  icon?: ReactNode;
  hideCount?: boolean;
};

export const Progression = ({ count, max = 5, icon, hideCount }: Props) => {
  return (
    <Progress>
      {icon}
      <ProgressBar>
        {range(max).map((x, i) => {
          return <span key={x} className={classNames({ active: i < count })} />;
        })}
      </ProgressBar>
      {!hideCount && (
        <BodyM bold>
          <FormattedMessage
            id="ReferralBar.count"
            defaultMessage="{count} out of {max}"
            values={{ count: count < max ? count : max, max }}
          />
        </BodyM>
      )}
    </Progress>
  );
};
